class CartReservationTimer {
  constructor() {
    // Wait for elements to be available
    this.waitForElements().then(() => {
      this.timerElement = document.getElementById('cart-reservation-timer');
      this.countdownElement = document.getElementById('timer-countdown');
      this.duration = 10 * 60; // 10 minutes in seconds
      this.interval = null;
      this.startTime = null;
      
      this.init();
    });
  }

  waitForElements() {
    return new Promise((resolve) => {
      const checkElements = () => {
        const timerElement = document.getElementById('cart-reservation-timer');
        const countdownElement = document.getElementById('timer-countdown');
        
        if (timerElement && countdownElement) {
          resolve();
        } else {
          setTimeout(checkElements, 100);
        }
      };
      checkElements();
    });
  }

  init() {
    console.log('CartReservationTimer initialized');
    
    // Check if timer should be running
    this.startTime = localStorage.getItem('cart-timer-start');
    
    // Check if cart has items
    const cartDrawer = document.querySelector('#CartDrawer-CartItems');
    const cartItemCount = cartDrawer ? cartDrawer.querySelectorAll('.cart-item').length : 0;
    
    console.log('Cart item count on init:', cartItemCount);
    console.log('Stored start time:', this.startTime);
    
    if (this.startTime && this.shouldTimerBeVisible() && cartItemCount > 0) {
      console.log('Starting existing timer');
      this.startTimer();
    } else {
      console.log('Not starting timer - clearing if exists');
      // Clear timer if cart is empty or expired
      this.stopTimer();
    }
    
    // Listen for cart updates using pubsub (if available)
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.handleCartUpdate();
      });
    }
    
    // Listen for items added to cart
    document.addEventListener('cart:item-added', (event) => {
      console.log('Cart item added event received', event);
      this.startNewTimer();
    });
  }

  shouldTimerBeVisible() {
    if (!this.startTime) return false;
    
    const elapsed = Math.floor((Date.now() - parseInt(this.startTime)) / 1000);
    return elapsed < this.duration;
  }

  startNewTimer() {
    console.log('Starting new timer');
    this.startTime = Date.now().toString();
    localStorage.setItem('cart-timer-start', this.startTime);
    this.startTimer();
  }

  startTimer() {
    console.log('Starting timer, elements:', this.timerElement, this.countdownElement);
    if (!this.timerElement || !this.countdownElement) {
      console.log('Timer elements not found');
      return;
    }
    
    this.showTimer();
    this.updateDisplay();
    
    // Clear existing interval
    if (this.interval) {
      clearInterval(this.interval);
    }
    
    // Start new interval
    this.interval = setInterval(() => {
      this.updateDisplay();
    }, 1000);
  }

  updateDisplay() {
    if (!this.startTime) return;
    
    const elapsed = Math.floor((Date.now() - parseInt(this.startTime)) / 1000);
    const remaining = Math.max(0, this.duration - elapsed);
    
    if (remaining <= 0) {
      this.stopTimer();
      return;
    }
    
    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    
    if (this.countdownElement) {
      this.countdownElement.textContent = formattedTime;
    }
  }

  stopTimer() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    
    localStorage.removeItem('cart-timer-start');
    this.hideTimer();
  }

  showTimer() {
    console.log('Showing timer');
    if (this.timerElement) {
      this.timerElement.classList.remove('hidden');
      console.log('Timer shown, classes:', this.timerElement.className);
    } else {
      console.log('Timer element not found in showTimer');
    }
  }

  hideTimer() {
    console.log('Hiding timer');
    if (this.timerElement) {
      this.timerElement.classList.add('hidden');
    }
  }

  handleCartUpdate() {
    // Get cart item count from drawer
    const cartDrawer = document.querySelector('#CartDrawer-CartItems');
    const cartItemCount = cartDrawer ? cartDrawer.querySelectorAll('.cart-item').length : 0;
    
    // If cart is empty, stop timer
    if (cartItemCount === 0) {
      this.stopTimer();
    }
  }
}

// Global timer instance
window.cartTimer = null;

function initializeTimer() {
  console.log('Initializing cart timer');
  if (window.cartTimer) {
    // Clean up existing timer
    if (window.cartTimer.interval) {
      clearInterval(window.cartTimer.interval);
    }
  }
  window.cartTimer = new CartReservationTimer();
}

// Initialize timer when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTimer);
} else {
  initializeTimer();
}

// Re-initialize timer when cart drawer is updated
document.addEventListener('DOMContentLoaded', () => {
  // Listen for cart drawer updates
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasCartDrawerUpdate = addedNodes.some(node => 
          node.nodeType === 1 && 
          (node.id === 'CartDrawer-CartItems' || node.querySelector && node.querySelector('#CartDrawer-CartItems'))
        );
        
        if (hasCartDrawerUpdate) {
          console.log('Cart drawer updated, reinitializing timer');
          setTimeout(initializeTimer, 100);
        }
      }
    });
  });
  
  const cartDrawer = document.querySelector('#CartDrawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
}); 